import styled from 'styled-components';
import { NavigationBar, SelectField as Select } from '@oneaudi/unified-web-components';

import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const SkipToWrapper = styled.section`
  height: 108px;
  @media (min-width: 480px) {
    height: auto;
  }
`;

export const Container = styled.div<{ isStuck?: boolean; isFiltersOpen: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  position: ${({ isStuck }) => (isStuck ? 'fixed' : 'relative')};
  top: 0;
  left: 0;
  right: 0;
  box-shadow: ${({ isStuck }) =>
    isStuck ? '0px 1px 2px 0px rgba(0, 0, 0, 0.1), 0px 2px 6px 0px rgba(0, 0, 0, 0.2)' : 'unset'};
  background-color: ${({ isStuck }) => (isStuck ? COLORS.white : 'relative')};
  z-index: 2;
  padding: ${({ isStuck }) => (isStuck ? ' 24px 18px 16px 18px' : '48px 0 0 0')};
  @media ${device.tablet} {
  }
  @media ${device.laptop} {
    justify-content: center;
  }
`;

export const CopyOne = styled.p`
  color: ${COLORS.grey80};
  font-size: 16px;
  letter-spacing: 0.002px;
  line-height: 24px;
  text-align: center;
`;

export const NavigationWrapper = styled.div`
  margin-left: -12px;
`;

export const DesktopWrapper = styled.div`
  display: none;
  @media ${device.laptop} {
    display: block;
  }
`;

export const MobileWrapper = styled.div`
  /* height: 77px; */
  @media ${device.laptop} {
    display: none;
  }
  label:not(:focus-within) {
    color: ${COLORS.grey80};
    font-family: 'Audi Type';
    white-space: nowrap;
  }
  .hasValue {
    label:not(:focus-within) {
      animation-name: none;
      color: ${COLORS.grey80};
      font-family: 'Audi Type';
      white-space: nowrap;
    }
  }
`;

export const StyledNavigationBar = styled(NavigationBar)`
  a {
    font-family: 'Audi Type';
  }
  #nav-default {
    visibility: hidden;
    width: 0;
  }
`;

export const FilterWrapper = styled.div<{ invisible?: boolean }>`
  /* visibility: ${(props) => (props.invisible ? 'hidden' : '')};
  position: absolute; */
  top: 25px;
  left: 28px;
  @media ${device.tablet} {
    top: 16px;
    left: 40px;
  }
  @media ${device.laptop} {
    top: 32px;
    left: 60px;
  }
  @media ${device.laptopL} {
    top: 32px;
    left: 96px;
  }
`;

export const StyledSelect = styled(Select)`
  min-width: 185px;
  width: 185px;
  @media ${device.tablet} {
    width: 274px;
  }
`;

export const FiltersCTA = styled.button<{ invisible?: boolean }>`
  font-family: 'Audi Type';
  cursor: pointer;
  visibility: ${(props) => (props.invisible ? 'hidden' : '')};
  position: sticky;
  top: 0;
  box-shadow: inset 0 0 0 1px ${COLORS.black};
  border: none;
  background-color: transparent;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.black};
  @media ${device.tablet} {
    padding: 16px 24px;
    font-size: 16px;
    line-height: 24px;
    gap: 12px;
  }
`;
